import { CloseOutlined } from "@ant-design/icons";
import { Input, message } from "antd";
import React, { useState } from "react";
import useAxios from "../../hooks/useAxios";

const ExtraScore = ({ candidate, setExtraScore, setLoad, loadCandidate, isDocumentSent }) => {
  const api = useAxios();
  const [score, setScore] = useState(candidate?.additionalScore ?? "");
  const close = () => {
    setExtraScore(false);
    setScore(candidate?.additionalScore ?? "");
  };

  const saveScore = async () => {
    try {
      setLoad(true);
      await api.put(
        `/candidate/additionalScore/${candidate?._id}`,
        {
          additionalScore: score === "" ? null : score,
        },
        { tokenType: "user" },
      );
      if (loadCandidate) {
        await loadCandidate();
      }
      message.success("Score updated successfully.");
      setExtraScore(false);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="row mb-2">
      <style>{`
        .custom-score-input:focus,
        .custom-score-input-focused,
        .custom-score-input:hover {
          border-color: #19466b !important;
          box-shadow: 0 0 0 2px rgba(25, 70, 107, 0.2) !important;
        }
      `}</style>
      <div className="col-12 flex justify-between items-start">
        <div className="flex flex-col mb-0">
          <div className="font-semibold text-[14px]">
            {isDocumentSent ? "Additional Score" : "Enter score for additional tests conducted"}
          </div>
        </div>
        <div>
          <button onClick={(e) => close()}>
            <CloseOutlined style={{ fontSize: "14px" }} />
          </button>
        </div>
      </div>
      <div className="col-12 mt-1">
        <div className="d-flex align-items-center gap-2">
          <Input
            type="text"
            className="custom-score-input"
            value={score}
            onChange={(e) => {
              if (isDocumentSent) return;
              setScore(e.target.value);
            }}
            readOnly={isDocumentSent}
            disabled={isDocumentSent}
            style={{ flex: 1 }}
            placeholder="Enter Score..."
          />
          {!isDocumentSent && (
            <button
              onClick={() => {
                saveScore();
              }}
              className="btn btn-primary"
              style={{ whiteSpace: "nowrap" }}
            >
              <span className="flex items-center text-[14px] font-semibold text-center">
                Save
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExtraScore;
